import { isDemoLocation } from '@/config/constants';

export const getEnvironmentType = () => {
  const url = process.env.CORE || window.location.hostname;
  if (isDemoLocation) {
    if (!url.includes('stage.')) {
      return 'dev';
    }
    return 'stage';
  }

  return 'production';
};
